import axios from "axios";

export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost/psprcm/psprcm-app";

// Token storage helpers -------------------------------------------------
export const getToken = () => localStorage.getItem("authToken");
export const setToken = (token) => localStorage.setItem("authToken", token);
export const clearToken = () => localStorage.removeItem("authToken");

// Axios instance --------------------------------------------------------
const api = axios.create({
  baseURL: API_URL,
});

// Attach JWT to every request.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global response handling: auto-logout on 401.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Do not force logout on the login request itself.
    if (status === 401 && !url.includes("/auth/login")) {
      clearToken();
      localStorage.removeItem("user");
      window.dispatchEvent(new Event("userUpdated"));
      const currentPath = window.location.pathname || "";
      const redirectPath = currentPath.startsWith("/auth/user/login")
        ? "/auth/user/login/"
        : "/auth/admin/login/";
      if (!currentPath.startsWith("/auth/admin/login") && !currentPath.startsWith("/auth/user/login")) {
        window.location.href = redirectPath;
      }
    }
    return Promise.reject(error);
  }
);

// Normalizes an axios error into a readable message.
export const apiError = (error, fallback = "Something went wrong.") =>
  error?.response?.data?.message || error?.message || fallback;

export default api;
